import { frameKindOf } from '../QuestionSessionBody/frameKind';
import AnswerFreeText from '../../Answer/AnswerFreeText/AnswerFreeText';
import AnswerSelect from '../../Answer/AnswerSelect/AnswerSelect';
import AnswerSelectWithRadio from '../../Answer/AnswerSelectWithRadio/AnswerSelectWithRadio';
import Loading from '../../Loading/Loading';
import QuestionSessionBody from '../QuestionSessionBody/QuestionSessionBody';
import Show from '../../Show/Show';
import { FC, useEffect } from 'react';
import { SPACING } from '../../../config/designSystem/Spacing';
import { observer } from 'mobx-react';
import { useBreakpointWidth } from '../../../hooks/useBreakpointWidth';
import { useNavigation } from 'expo-router';
import { useStores } from '../../../hooks/useStores';

interface QuestionSessionProps {
  onNext?: () => void;
  onFinish?: () => void;
}
const _QuestionSession: FC<QuestionSessionProps> = ({
  onNext = () => console.error('QuestionSession.onNext not implemented'),
  onFinish = () => console.error('QuestionSession.onFinish not implemented'),
}) => {
  const { treeNav, question: questionStore } = useStores();
  const navigation = useNavigation();

  const question = treeNav.content.question;

  const MARGIN = useBreakpointWidth({
    lg: SPACING['sp-200'],
    md: SPACING['sp-64'],
    sm: SPACING['sp-16']});

  // initialise current user choices
  useEffect(() => {
    if (question?._id) {
      treeNav.choices.restorePendingChoicesForQuestion({questionId: question._id});
    }
  }, [navigation, treeNav, question?._id]);


  const handleOnNext = () => {
    onNext();
  };

  if (!question) {
    const sessionStepContentId = treeNav.content.sessionStep?.contentId;
    const questionId = treeNav.content.contentId;
    // A question this screen has not received YET is the normal first frame of every
    // survey, not a fault: the tree node lands before the fetch resolves. Logging that
    // as an error flashed a red toast on onboarding step 1 and, because console.error
    // is captured, filed it in Sentry -- while the question arrived fine milliseconds
    // later.
    //
    // Only a fetch that actually FAILED is worth shouting about. Note isReady() is not
    // the test: it returns true when the id has no state entry at all, which is
    // precisely the pre-fetch case we are trying to stay quiet about.
    if (!!questionId && questionStore.hasError(questionId)) {
      console.error(`undefined question for contentId=${questionId}, sessionStepContentId=${sessionStepContentId}`);
    }
    return <Loading />;
  }
  console.log('QuestionSession.render', {questionId: question._id, questionType: question.type});
  // a question drawn by its uiDesign (flowers, diaries, journal) brings its own answer UI
  const drawnByDesign = !!frameKindOf(question);

  return (
    <>
      <Show when={true}>
        <QuestionSessionBody
          question={question}
          margin={MARGIN}
        />
        <Show when={!drawnByDesign && question?.type && ['singleSelect', 'multiSelect'].includes(question.type)}>
          <AnswerSelect
            question={question}
            onNext={handleOnNext}
          />
        </Show>
        <Show when={question?.type === 'singleSelectWithRadio'}>
          <AnswerSelectWithRadio
            question={question}
            onNext={handleOnNext}
          />
        </Show>
        <Show when={question?.type === 'range'}>
          {/**
            <AnswerRange
              question={question}
              margin={MARGIN}
            />
             */}
        </Show>
        <Show when={!drawnByDesign && question?.type === 'freeText'}>
          <AnswerFreeText
            question={question}
          />
        </Show>
      </Show>
    </>
  );

};

export const QuestionSession = observer(_QuestionSession);
